import Source from '../Source';
import MapProperties from '../../map/Properties';

import store from '../../../store/configureStore';

let loaded_state = {};
let fetched_data = {};
let elcitaToiletsData = [];
let elcitaToiletsDataFetched = false;
export default class JGRICMYCSource extends Source {
    currentView = new MapProperties();
    isLoading = false;
    loadComplete = false;
    url = '';
    coverage = [];
    features = new Map();
    constructor(initializer = {}) {
        super(initializer);
        Object.assign(this, initializer);
        this.fetchData();
    }
    fetchData() {
        if(elcitaToiletsDataFetched === false){
            fetch("https://rbndapi.cloudhop.in/es/elcita_toilets/_search")
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                elcitaToiletsDataFetched = true;
                elcitaToiletsData = data.hits.hits[0]._source.results;
            })   
        }
        let url = "https://rbndapi.cloudhop.in/es/jgricmyc_sn_demo/_doc/_search?size=1000";
        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                fetched_data['jgricmyc_sn_demo'] = data;
            })

        fetch("https://rbndapi.cloudhop.in/es/jgricmyc_response/_doc/_search?size=1000")
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                fetched_data['jgricmyc_response'] = data;
            })
    }
    initialize() {
        if (store) {
            store.subscribe(JGRICMYCSource.onMoveMap);
        }
    }
    setLoadingFlag() {
        this.isLoading = true;
        this.loadComplete = false;
    }
    unsetLoadingFlag() {
        this.isLoading = false;
        this.loadComplete = true;
    }
    getSchoolDataInView() {
        let map = (store.getState()).map;
        if (map.view.zoom < 14)
            return new Map();
        let north_latitude = map.view.bounds._northEast.lat;
        let south_latitude = map.view.bounds._southWest.lat;
        let west_longitude = map.view.bounds._southWest.lng;
        let east_longitude = map.view.bounds._northEast.lng;
        if (this.features) {
            let features = (Array.from(this.features)).map(([key, feature]) => {
                if ((feature.geometry.coordinates[1] < north_latitude)
                    && (feature.geometry.coordinates[1] > south_latitude)
                    && (feature.geometry.coordinates[0] < east_longitude)
                    && (feature.geometry.coordinates[0] > west_longitude)) {
                    return [key, feature];
                }
            }).filter((feature) => feature !== undefined);
            return new Map(features);
        }
        return new Map();
    }

    processSnDemoFetchedData(data, selectedSetting) {
        let govJgrSource = data.hits.hits[0]._source.data
        let countJgr = govJgrSource.length;
        let govFeaturesData = [];
        govJgrSource.forEach(element => {
            if (element.subCategory.toLowerCase().indexOf(selectedSetting) >= 0) {
                govFeaturesData.push({
                    "type": "Feature",
                    "geometry": {
                        "coordinates": [Number(element.location.longitude), Number(element.location.latitude)],
                        "type": "Point"
                    },
                    "properties": {
                        "mla": null,
                        "constituency": null,
                        "party": null,
                        "id": element.id,
                        'pincode': null,
                        'corporator_name': null,
                        'contact_no': null,
                        'age': null,
                        'address': null,
                        "ward_no": element.wardTitle,
                        "subCategory": element.subCategory,
                        "category": element.category,
                        "description": element.description,
                        "civicAgency": element.civicAgency,
                        "statusTitle": element.statusTitle,
                        "type": {
                            "id": "govjgr",
                            "name": "govjgr"
                        },
                        "categoryValue": selectedSetting
                    }
                })
            }
        })
        return govFeaturesData;
    }

    processJgricymyResponse(data, govFeaturesData, selectedSetting) {
        let govJgrResponseHits = data.hits;
        let govJgrResponseSource = [];
        govJgrResponseHits.hits.forEach(element => {
            govJgrResponseSource.push(element._source);
        })
        govJgrResponseSource.forEach(element => {
            if (element.sub_category_title != undefined) {
                if (element.sub_category_title.toLowerCase().indexOf(selectedSetting) >= 0) {
                    govFeaturesData.push({
                        "type": "Feature",
                        "geometry": {
                            "coordinates": [Number(element.longitude), Number(element.latitude)],
                            "type": "Point"
                        },
                        "properties": {
                            "mla": null,
                            "constituency": null,
                            "party": null,
                            "id": element.id,
                            'pincode': null,
                            'corporator_name': null,
                            'contact_no': null,
                            'age': null,
                            'address': null,
                            "ward_no": element.ward_title,
                            "subCategory": element.sub_category_title,
                            "category": element.category_title,
                            "description": element.description,
                            "civicAgency": element.civic_agency_title,
                            "statusTitle": element.status_title,
                            "type": {
                                "id": "govjgr",
                                "name": "govjgr"
                            },
                            "categoryValue": selectedSetting
                        }
                    })
                }
            }
        })
    }

    processFinalResponse(govFeaturesData, currentView) {
        let uids = [];
        if ((store.getState()).viewSettings["sanitation"]) {
            debugger;
            elcitaToiletsData.forEach((element, index) => {
                govFeaturesData.push({
                    "type": "Feature",
                    "geometry": {
                        "coordinates": [Number(element.longitude), Number(element.latitude)],
                        "type": "Point"
                    },
                    "properties": {
                        "id": 100000 + index,
                        "ward_name": element.client,
                        "title": element.unit,
                        "category": element.access,
                        "status": element.status,
                        "type": {
                            "id": "elcitaToilets",
                            "name": "elcitaToilets"
                        },
                        "categoryValue": "elcitaToilets"
                    }
                })
            })

        }
        let govFinalDataFormat = {
            "features": govFeaturesData,
            "count": govFeaturesData.length,
            "type": "FeatureCollection"
        }
        if ((govFinalDataFormat.count) && (govFinalDataFormat.count > 0)) {
            for (var i = 0; i < govFinalDataFormat.count; i++) {
                uids.push(govFinalDataFormat.features[i].properties.id);
            }
        }
        store.dispatch({
            type: JGRICMYCSource.ACTIONS.JGRICMYC_DATA_LOAD_COMPLETE,
            view: currentView,
            data: govFinalDataFormat,
            uids
        });
        store.dispatch({
            type: MapProperties.ACTIONS.ADD_FEATURES,
            data: govFinalDataFormat,
            uids
        });
    }

    static onMoveMap() {
        //Check for the selected category
        let selectedSetting = ""
        if (!((store.getState()).viewSettings["pothole"]) && !((store.getState()).viewSettings["waste"]) && !((store.getState()).viewSettings["sanitation"])) {
            return;
        } else {
            if (((store.getState()).viewSettings["pothole"]) && (loaded_state["pothole"] === undefined)) {
                selectedSetting = "pothole"
            } else if (((store.getState()).viewSettings["waste"]) && (loaded_state["garbage"] === undefined)) {
                selectedSetting = "garbage"
            } else if (((store.getState()).viewSettings["sanitation"]) && (loaded_state["others"] === undefined)) {
                selectedSetting = "others"
            } else {
                selectedSetting = "air or all category already selected"
            }

            if (selectedSetting !== "air or all category already selected") {
                let currentView = (store.getState()).map;
                let jgrIcmyc = (store.getState()).jgrIcmyc;
                if ((loaded_state[selectedSetting] === undefined) && (!jgrIcmyc.isLoading)
                    && (currentView.view.zoom > 14)) {
                    let area_already_covered = false;
                    loaded_state[selectedSetting] = true;
                    for (var i = 0; i < jgrIcmyc.coverage.length; i++) {
                        let center = (jgrIcmyc.coverage[i]).center;
                        let lat1 = center.lat,
                            lng1 = center.lng,
                            lat2 = currentView.view.center.lat,
                            lng2 = currentView.view.center.lng;
                        let φ1 = (parseFloat(lat1) / 180) * Math.PI,
                            φ2 = (parseFloat(lat2) / 180) * Math.PI,
                            Δλ = (parseFloat(lng2 - lng1) / 180) * Math.PI,
                            R = 6371e3;
                        let d = Math.acos(
                            Math.sin(φ1) * Math.sin(φ2) +
                            Math.cos(φ1) * Math.cos(φ2) * Math.cos(Δλ)) * R;
                    }
                    if (!area_already_covered) {
                        store.dispatch({
                            type: JGRICMYCSource.ACTIONS.BEGIN_JGRICMYC_DATA_LOAD
                        });
                        if ((currentView) && (currentView.view)
                            && (currentView.view.center) && (currentView.view.center.lat)
                            && (currentView.view.center.lng) && (currentView.view.radius)
                            && (currentView.view.zoom)) {
                            let north_latitude = currentView.view.bounds._northEast.lat;
                            let south_latitude = currentView.view.bounds._southWest.lat;
                            let west_longitude = currentView.view.bounds._southWest.lng;
                            let east_longitude = currentView.view.bounds._northEast.lng;
                            //fetch value from sn_demo complaints
                            jgrIcmyc.url = "https://rbndapi.cloudhop.in/es/jgricmyc_sn_demo/_doc/_search?size=1000";
                            let govFeaturesData = {};
                            if (fetched_data['jgricmyc_sn_demo'] === undefined) {
                                fetch(jgrIcmyc.url)
                                    .then((response) => {
                                        return response.json();
                                    })
                                    .then((data) => {
                                        fetched_data['jgricmyc_sn_demo'] = data;
                                        let govFeaturesData = jgrIcmyc.processSnDemoFetchedData(data, selectedSetting);
                                        //Fetch value from newly added complaints
                                        fetch("https://rbndapi.cloudhop.in/es/jgricmyc_response/_doc/_search?size=1000")
                                            .then((response) => {
                                                return response.json();
                                            })
                                            .then((data) => {
                                                fetched_data['jgricmyc_response'] = data;
                                                jgrIcmyc.processJgricymyResponse(data, govFeaturesData, selectedSetting);
                                                jgrIcmyc.processFinalResponse(govFeaturesData, currentView);
                                            })
                                    })
                            } else {
                                let govFeaturesData = jgrIcmyc.processSnDemoFetchedData(fetched_data['jgricmyc_sn_demo'], selectedSetting);
                                if (fetched_data['jgricmyc_response'] === undefined) {
                                    fetch("https://rbndapi.cloudhop.in/es/jgricmyc_response/_doc/_search?size=1000")
                                        .then((response) => {
                                            return response.json();
                                        })
                                        .then((data) => {
                                            fetched_data['jgricmyc_response'] = data;
                                            jgrIcmyc.processJgricymyResponse(data, govFeaturesData, selectedSetting);
                                            jgrIcmyc.processFinalResponse(govFeaturesData, currentView);
                                        })
                                } else {
                                    jgrIcmyc.processJgricymyResponse(fetched_data['jgricmyc_response'], govFeaturesData, selectedSetting);
                                    jgrIcmyc.processFinalResponse(govFeaturesData, currentView);
                                }
                            }
                        }
                    }
                }
            }

        }
    }
    static get ACTIONS() {
        return {
            BEGIN_JGRICMYC_DATA_LOAD: 'BEGIN_JGRICMYC_DATA_LOAD',
            JGRICMYC_DATA_LOAD_COMPLETE: 'JGRICMYC_DATA_LOAD_COMPLETE'
        };
    }
    static reducer(state = {}, action) {
        switch (action.type) {
            case JGRICMYCSource.ACTIONS.BEGIN_JGRICMYC_DATA_LOAD: {
                let jgrIcmyc = new JGRICMYCSource(state);
                jgrIcmyc.setLoadingFlag();
                return jgrIcmyc;
            }
            case JGRICMYCSource.ACTIONS.JGRICMYC_DATA_LOAD_COMPLETE: {
                let jgrIcmyc = new JGRICMYCSource(state);
                jgrIcmyc.unsetLoadingFlag();
                jgrIcmyc.currentView = action.view;
                jgrIcmyc.coverage = ([].concat(jgrIcmyc.coverage)).concat([
                    {
                        center: Object.assign({}, action.view.view.center),
                        radius: action.view.view.radius,
                    }
                ]);
                if ((action.data.count) && (action.data.count > 0)) {
                    action.data.features.map((feature, index) => {
                        if (jgrIcmyc.features.has(action.uids[index])) {
                        } else {
                            jgrIcmyc.features.set(action.uids[index], feature);
                        }
                    });
                }
                return jgrIcmyc;
            }
            default: {
                return state;
            }
        }
    }

    componentDidMount() {
    }

}


// WEBPACK FOOTER //
// ./src/models/source/jgrIcmyc/index.js